<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="contactRequestHeader" class="page-name color-71aa3f">
                        Create Contact Request
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backShowContactRequestList">Back</button>
                </div>
                <div class="admin-page-content">
                    <form id="contactRequestForm">
                        <div class="forms-container">
                            <div class="row no-margin">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                    <div class="alert alert-success" id="alertSuccess">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <span>Contact Request Added Successfully</span>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>First Name</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input name="first_name" id="first_name"
                                               class="form-control no-resize" v-model="first_name"
                                               placeholder="Enter First Name"
                                               v-validate="'required'">       
                                        <div class="requiredstar">*</div>
                                        <span v-show="errors.has('first_name')" class="help is-danger"><font color="red">First Name is Required</font></span>
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Last Name</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input name="last_name" id="last_name"
                                               class="form-control no-resize" v-model="last_name"
                                               placeholder="Enter Last Name">
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Organization Name</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input name="organization_name" id="organization_name"
                                               class="form-control no-resize" v-model="organization_name"
                                               placeholder="Enter Organization Name"
                                               v-validate="'required'">
                                        <div class="requiredstar">*</div>
                                        <span v-show="errors.has('organization_name')" class="help is-danger"><font color="red">Organization Name is Required</font></span>
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Preferred Contact Method</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <v-select
                                            name="contact_method"
                                            v-model="contact_method"
                                            id="contact_method" label="text"
                                            :options="contactMethodArr"
                                            :required="true"
                                            v-validate="'required'">
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <span v-show="errors.has('contact_method')" class="help is-danger"><font color="red">Preferred Contact Method is Required</font></span>
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Phone No.</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input name="phone" id="phone"
                                               class="form-control no-resize" v-model="phone"
                                               placeholder="Enter Phone No."
                                               v-validate="'required'">
                                        <div class="requiredstar">*</div>
                                        <span class="help is-danger" v-if="errors.has('phone')" v-show="phone == ''"><font color="red">Phone No. is Required<br></font></span>
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Email</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input name="email" id="email"
                                               class="form-control no-resize" v-model="email"
                                               placeholder="Enter Email"
                                               v-validate="'required|email'"
                                               >
                                        <div class="requiredstar">*</div>
                                        <!-- <span class="help is-danger" v-if="errors.has('email')"><font color="red">{{errors.first('email')}}</font></span> -->
                                        <span class="help is-danger" v-if="errors.first('email')" v-show="email != ''"><font color="red">Email Must Be A Valid Email</font></span>
                                        <span class="help is-danger" v-if="errors.has('email')" v-show="email == ''"><font color="red">Email is Required</font></span>
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Contact Reason</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input name="reason" id="reason"
                                               class="form-control no-resize" v-model="reason"
                                               placeholder="Enter Contact Reason">
                                    </div>    
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Collector</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <v-select 
                                            v-model="user_id" 
                                            @change="userChangedValue" 
                                            name="user_id" 
                                            label="text" 
                                            :filterable="false" 
                                            :options="usersArr" 
                                            @search="onSearch"
                                            v-validate="'required'"
                                            placeholder="Select Collector">
                                            <template slot="no-options">
                                                Search Collectors...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <span v-show="errors.has('user_id')" class="help is-danger" v-if="errors.has('user_id')"><font color="red">Collector is Required</font></span>
                                    </div>    
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="col-1point5 paddingleft0">
                                        <div class="form-label"><strong>Comment</strong></div>
                                    </div>
                                    <div class="col-10point5 paddingleft0">
                                        <textarea rows="10" name="comment" id="comment"
                                                  class="form-control no-resize" v-model="comment"
                                                  placeholder="Enter Comment">
                                        </textarea>
                                    </div>    
                                </div>
                                <div class="col-12">
                                    <div class="col-12 paddingleft0">
                                        <input id="addContactRequestBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="addContactRequest()">
                                        <!-- <button id="addCaseBtn" type="submit" class="btn general-button btn-primary" v-on:click.prevent="addCase">{{btn}}</button> -->
                                        <input id="addAndContinueContactRequestBtn" type="submit" value="Save and Continue" class="btn general-button btn-primary" v-on:click.prevent="addContactRequest(flag='Save and Continue')">
                                        <input id="CancelContactRequest" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backShowContactRequestList">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div> 
</template>
<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import EventBus from '../event-bus';
    import FrontFooter from '@/components/partials/FrontFooter';
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: 'ContactRequestCreate',
        components: {
            'app-footer': FrontFooter,
        },
        mixins: [SessioMixin],
        data() {
            return{
                cantAccessPage: true,
                isLoggedIn: false,
                first_name: '',
                last_name: '',
                organization_name: '',
                contact_method: {value: 'email', text: "Email"},
                contactMethodArr: [{value: 'email', text: "Email"},
                    {value: 'phone', text: "Phone"},
                ],
                phone: '',
                email: '',
                reason: '',
                comment: '',
                user_id: "",
                usersArr: [],
                options: '',
            }
        },

        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            $("#menucontactrequest").addClass("active");
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            if (segments[3]) {
                self.showLoader();
                //console.log(segments[3]);
                self.loadContactRequest();
                // $("#addAndContinueCaseBtn").prop('disabled',true);
                $('#addAndContinueContactRequestBtn').hide();
                $("#addContactRequestBtn").val('Update');
                $("#contactRequestHeader").text('Edit Contact Request');
            }
            //console.log(segments[3]);
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_contact_request') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            backShowContactRequestList() {
                var self = this;
                self.$router.push('/contact_request/list');

            },
            userChangedValue: function (value) {

                //console.log("", value);
            },

            onSearch(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadUser(loading, search, this);
                }

            },
            onSubmit(flag) {
                this.$validator.validateAll();

                if (!this.errors.any()) {
                    this.addContactRequest(flag);
                }
            },

            loadUser(loading, search, vm) {

                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        type: 'collector',
                    },
                    dataType: 'json',
                    success: function (data) {
                        loading(false);

                        self.usersArr = data;

                        //console.log(self.usersArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                })

            },

            addContactRequest(flag) {
                this.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var self = this;
                        //console.log(segments[3]);
                        if (segments[3]) {
                            //console.log(segments[3]);
                            $("#addContactRequestBtn").val('Updating ...');
                            $("#addContactRequestBtn").prop('disabled', true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelContactRequest").prop('disabled', true);
                            // this.$validator.validateAll();
                            // this.$validator.errors.clear();

                        } else {
                            if (flag == 'Save and Continue') {
                                $("#addAndContinueContactRequestBtn").val('Saving ...');
                                $("#addAndContinueContactRequestBtn").prop('disabled', true);
                                $("#addContactRequestBtn").prop('disabled', true);
                                $("#CancelContactRequest").prop('disabled', true);
                            } else {
                                $("#addContactRequestBtn").val('Saving ...');
                                $("#addContactRequestBtn").prop('disabled', true);
                                $("#addAndContinueContactRequestBtn").prop('disabled', true);
                                $("#CancelContactRequest").prop('disabled', true);

                            }


                        }
                        var fields = $('#contactRequestForm').serializeArray();
                        fields.push({name: 'contact_method', value: self.contact_method.value});
                        fields.push({name: 'user_id', value: self.user_id.value});

                        if (segments[3]) {
                            fields.push({name: 'id', value: segments[3]});
                            fields.push({name: 'contact_method', value: self.contact_method.value});
                            fields.push({name: 'user_id', value: self.user_id.value});


                        } else {
                            fields.push({name: 'id', value: 0});
                        }
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/contact_request/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                if (segments[3]) {
                                    //console.log(segments[3]);
                                    $("#addContactRequestBtn").val('Update');
                                    $("#addContactRequestBtn").prop('disabled', false);
                                    // $("#addAndContinueCaseBtn").prop('disabled',true);
                                    $("#CancelContactRequest").prop('disabled', false);

                                } else {
                                    if (flag == 'Save and Continue') {
                                        $("#addAndContinueContactRequestBtn").val('Save and Continue');
                                        $("#addAndContinueContactRequestBtn").prop('disabled', false);
                                        $("#addContactRequestBtn").prop('disabled', false);
                                        $("#CancelContactRequest").prop('disabled', false);
                                    } else {
                                        $("#addContactRequestBtn").val('Save');
                                        $("#addContactRequesteBtn").prop('disabled', false);
                                        $("#addAndContinueContactRequestBtn").prop('disabled', false);
                                        $("#CancelContactRequest").prop('disabled', false);

                                    }
                                }

                                if (data.status == "success") {

                                    if (flag == 'Save and Continue') {
                                        $('html, body').animate({scrollTop: '0px'}, 500);
                                        $(".alert-success").parent().removeClass('hide');
                                        $(".alert-success").parent().addClass('show');
                                        self.first_name = '';
                                        self.last_name = '';
                                        self.organization_name = '';
                                        self.contact_method = {value: 'email', text: "Email"};
                                        self.phone = '';
                                        self.email = '';
                                        self.reason = '';
                                        self.comment = '';
                                        self.user_id = '';
                                        self.usersArr = [];
                                        setTimeout(function () {
                                            $('.alert-success').parent().removeClass('show');
                                            $('.alert-success').parent().addClass('hide');
                                        }, 5000);

                                    } else {
                                        self.$router.push('/contact_request/list');
                                    }

                                } else {

                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);
                                    }
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[3]) {
                                    $("#addContactRequestBtn").val('Update');
                                    $("#addContactRequestBtn").prop('disabled', false);
                                    // $("#addAndContinueCaseBtn").prop('disabled',true);
                                    $("#CancelContactRequest").prop('disabled', false);
                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-danger").parent().removeClass('hide');
                                    $(".alert-danger").parent().addClass('show');
                                    setTimeout(function () {
                                        $('.alert-danger').parent().removeClass('show');
                                        $('.alert-danger').parent().addClass('hide');
                                    }, 5000);
                                } else {

                                    if (flag == 'Save and Continue') {
                                        $("#addAndContinueContactRequestBtn").prop('disabled', false);
                                        $("#addAndContinueContactRequestBtn").val('Save and Continue');
                                        $("#addContactRequestBtn").prop('disabled', false);
                                        $("#CancelContactRequest").prop('disabled', false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        self.first_name = '';
                                        self.last_name = '';
                                        self.organization_name = '';
                                        self.contact_method = {value: 'email', text: "Email"};
                                        self.phone = '';
                                        self.email = '';
                                        self.reason = '';
                                        self.comment = '';
                                        self.user_id = '';
                                        self.usersArr = [];
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);

                                    } else {
                                        $("#addContactRequestBtn").val('Save');
                                        $("#addContactRequestBtn").prop('disabled', false);
                                        $("#addAndContinueContactRequestBtn").prop('disabled', true);
                                        $("#CancelContactRequest").prop('disabled', false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);
                                    }


                                }

                                if (jqXHR.status == 0) {
                                    self.errorMsg = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }

                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-danger").parent().removeClass('hide');
                                    $(".alert-danger").parent().addClass('show');
                                    setTimeout(function () {
                                        $('.alert-danger').parent().removeClass('show');
                                        $('.alert-danger').parent().addClass('hide');
                                    }, 5000);
                                }
                            }
                        });
                    }
                });
            },
            loadContactRequest() {
                var path = window.location.pathname;
                var segments = path.split("/");
                //console.log(segments[3]);
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/contact_request/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    // dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        //console.log(data);
                        self.first_name = data[0].first_name;
                        self.last_name = data[0].last_name;
                        self.organization_name = data[0].organization_name;
                        self.contact_method = {value: data[0].contact_method, text: self.formatString(data[0].contact_method)};
                        self.phone = data[0].phone;
                        self.email = data[0].email;
                        self.user_id = {value: data[0].user_id, text: data[0].user_first_name + " " + data[0].user_last_name /*+ " - " + data[0].user_email*/};
                        self.reason = data[0].reason;
                        self.comment = data[0].comment;



                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            getAccountId: function (id) {

                var self = this;

                //console.log("hello" + id);
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
        },

    }
</script>




// WEBPACK FOOTER //
// src/components/contactRequest/ContactRequestCreate.vue